import { render, staticRenderFns } from "./welcome-optional-section.vue?vue&type=template&id=e6d4ad02&scoped=true&"
import script from "./welcome-optional-section.vue?vue&type=script&lang=js&"
export * from "./welcome-optional-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d4ad02",
  null
  
)

export default component.exports